import { createAction, props } from '@ngrx/store';
import { IShareholderSummaryInfo } from '@appShared/interfaces/[Model-based]/shareholder-summary-info.interface';
const apiLevelEventPrefix = '[Shareholder Page API]';

export const loadShareholdersSuccess = createAction(
  `${apiLevelEventPrefix} Load Shareholders Success`,
  props<{ shareholders: IShareholderSummaryInfo[] }>()
);

export const loadShareholdersFailure = createAction(
  `${apiLevelEventPrefix} Load Shareholders Failure`,
  props<{ error: string }>()
);
